import { render, staticRenderFns } from "./DialogConfirm.vue?vue&type=template&id=35e6dc3c&scoped=true"
import script from "./DialogConfirm.vue?vue&type=script&lang=js"
export * from "./DialogConfirm.vue?vue&type=script&lang=js"
import style0 from "./DialogConfirm.vue?vue&type=style&index=0&id=35e6dc3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e6dc3c",
  null
  
)

export default component.exports